import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'array-flat-polyfill';
import './polyfill/remove';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import axios from 'axios';
import smoothscroll from 'smoothscroll-polyfill';
import locale from '@glu/locale';
import { ThemeProvider } from '@glu/theming';
import {
  BrandingProvider,
  defaultStrings_en_US as localeBranding,
} from '@glu/interactive-styleguide';
import { oaoTheme } from '@ces/themes';
import isIE11 from 'utils/isIE11';
import Theme from './containers/Theme';
import store from './core/store';
import App from './App';
import * as serviceWorker from './serviceWorker';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
smoothscroll.polyfill();
locale.set(localeBranding);

// eslint-disable-next-line react/prop-types
const AppWithProvidersBase = ({ theme }) => {
  if (isIE11) {
    return (
      <ThemeProvider baseTheme={oaoTheme} theme={theme}>
        <App />
      </ThemeProvider>
    );
  }
  return (
    <BrandingProvider
      baseTheme={oaoTheme}
      theme={theme}
      useFlatStructure
      omitFromUploadMerge={['custom']}
    >
      <Theme theme={theme}>
        <App />
      </Theme>
    </BrandingProvider>
  );
};

const mapStateToProps = (state) => ({
  theme: state.theme,
});

const AppWithProviders = connect(mapStateToProps)(AppWithProvidersBase);

ReactDOM.render(
  <Provider store={store}>
    <AppWithProviders />
  </Provider>,
  document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
